export interface Testimonial {
  role: 'Driving Instructor' | 'Driving Educator'
  location: string
  text: string
  /** true until replaced with verified customer feedback */
  isSample: boolean
}

// Placeholder copy for layout only — replace with verified customer feedback before publication
// and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    role: 'Driving Instructor',
    location: 'United Kingdom',
    text: 'Having the lesson structure already organized completely changes my preparation. I can choose the skill, review the visual progression and know exactly what I want to work on with the student.',
    isSample: true,
  },
  {
    role: 'Driving Educator',
    location: 'Australia',
    text: 'The visual breakdowns are the strongest part for me. Parking, positioning and maneuvers are much easier to explain when the student can see the vehicle path before trying it.',
    isSample: true,
  },
  {
    role: 'Driving Instructor',
    location: 'Canada',
    text: 'The progressions, correction tools and assessments give my lessons much more structure. I spend less time preparing and more time actually teaching.',
    isSample: true,
  },
]
